import React, { forwardRef, IframeHTMLAttributes } from "react";
import IBuildrProps from "src/utilities/IBuildrProps";
import classNames from 'classnames';

interface IIFrameProps extends IBuildrProps, IframeHTMLAttributes<HTMLIFrameElement> { }

export const IFrame = forwardRef(({ cmsId, editorClassObj, ...props }: IIFrameProps, ref: any) => {
    return (
        <div data-id={cmsId} ref={ref} className={classNames(editorClassObj)}>
            <iframe {...props} />
        </div>
    )
});